// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'guildmates-app',
    appId: '1:388935362244:web:838613c4a8827f286ccb91',
    storageBucket: 'guildmates-app.appspot.com',
    apiKey: 'AIzaSyCfHPRCPEkIGpmkUue-grugux50ggO8eF8',
    authDomain: 'guildmates-app.firebaseapp.com',
    messagingSenderId: '388935362244',
    measurementId: 'G-ZWMRRH3B69',
  },
  production: true,
  API_BASE_URL: "https://api.guildmates.app/api",    // url for prod Strapi-based Backend

  // API_BASE_URL: "http://localhost:1337/api",    // url for local Strapi-based Backend
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
